import { Heading } from "@planningcenter/doxy-web"
import { Link } from "react-router-dom"
import { chunk } from "lodash"
import { ChurchCenterCustomFieldApiRecordWithRelationships } from "source/myChurchCenter/Profile/types"
import { useSearchParams } from "../hooks/useSearchParams"

export function CustomFields({
  records,
}: {
  records: ChurchCenterCustomFieldApiRecordWithRelationships[]
}) {
  const COLUMNS = 2
  const recordsInRows = chunk(records, COLUMNS)

  const [searchParams] = useSearchParams()
  const selectedProfileId = searchParams.get("profile")
  const editLink = `edit?profile=${selectedProfileId}`

  function Row({
    recordsTuple,
  }: {
    recordsTuple: ChurchCenterCustomFieldApiRecordWithRelationships[]
  }) {
    const [recordOne, recordTwo] = recordsTuple

    return (
      <div className="d-f@sm f_1 mb-1">
        <div>
          <dt className="c-tint2 fs-4">
            {recordOne.relationships.field_definition.data.attributes.name}
          </dt>
          <dd className="mb-1">
            <FieldValue record={recordOne} />
          </dd>
        </div>

        {recordTwo && (
          <div>
            <dt className="c-tint2 fs-4">
              {recordTwo.relationships.field_definition.data.attributes.name}
            </dt>
            <dd>
              <FieldValue record={recordTwo} />
            </dd>
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      <div className="d-f ai-c jc-sb mb-2">
        <Heading level={2} size={3} text="Additional information" />
        <Link
          to={editLink}
          className="minor-btn secondary-btn btn"
          style={{ zIndex: 0 }}
        >
          Edit
        </Link>
      </div>
      <dl className="action-drawer mb-4">
        {recordsInRows.map((recordsTuple, index) => (
          <Row key={index} recordsTuple={recordsTuple} />
        ))}
      </dl>
    </>
  )
}

function FieldValue({
  record,
}: {
  record: ChurchCenterCustomFieldApiRecordWithRelationships
}) {
  const NO_VALUE = "No value"

  const isCheckbox =
    record.relationships.field_definition.data.attributes.data_type ===
    "checkboxes"

  if (isCheckbox) {
    const values = record.relationships.field_data?.data.map(
      (data) => data.attributes.value,
    )
    return values?.length ? values.join(", ") : NO_VALUE
  }
  return record.relationships.field_data?.data[0]?.attributes?.value || NO_VALUE
}
